const memberRouter = {
  route: null,
  name: null,
  title: '会员管理',
  type: 'folder', // 类型: folder, tab, view
  icon: 'iconfont icon-tushuguanli',
  filePath: 'view/member/', // 文件路径
  order: 9,
  inNav: true,
  permission: ['会员列表', '会员身份认证列表', '会员常用游客列表'],
  children: [
    {
      title: '会员列表',
      type: 'view',
      name: 'MemberList',
      route: '/member/list',
      filePath: 'view/member/member-list.vue',
      inNav: true,
      icon: 'iconfont icon-tushuguanli',
      permission: ['会员列表'],
    },
    {
      title: '身份认证',
      type: 'view',
      name: 'MemberIdentityList',
      route: '/member/identities',
      filePath: 'view/member/member-identity-list.vue',
      inNav: true,
      icon: 'iconfont icon-tushuguanli',
      permission: ['会员身份认证列表'],
    },
    {
      title: '常用游客',
      type: 'view',
      name: 'MemberVisitorList',
      route: '/member/visitors',
      filePath: 'view/member/member-visitor-list.vue',
      inNav: true,
      icon: 'iconfont icon-tushuguanli',
      permission: ['会员常用游客列表'],
    },
    // {
    //   title: '会员添加',
    //   type: 'view',
    //   name: 'MemberList',
    //   route: '/member/add',
    //   filePath: 'view/member/add.vue',
    //   inNav: true,
    //   icon: 'iconfont icon-tushuguanli',
    // },
  ],
}

export default memberRouter
